import { getStore } from "core/redux/store/configureStore";
import queryString from "query-string";

export function excludeQueryStringFromUrl(url: string) {
  return url.split("?")[0];
}

export function currentUrlWithoutQueryString() {
  return excludeQueryStringFromUrl(window.location.href);
}

export function excludeAnchorFromUrl(url: string) {
  return url.split("#")[0];
}

/** Client base url (protocol + domain + port) */
export function clientBaseUrl() {
  return window.location.origin;
}

/** Base path (default /app/bx) */
// FIXME: Adapt for Selector
export function clientUrlBasePath() {
  return import.meta.env.BASE_URL || "/app/bx";
}

/** Build client full path: basePath + givenPath */
export function clientUrlPath(path: string) {
  const basePath = clientUrlBasePath();
  if (!path) {
    return basePath;
  }

  if (path.startsWith(basePath)) {
    return path;
  }

  return `${basePath}${path.startsWith("/") ? "" : "/"}${path}`;
}

/** Build full url: https://domain.com:1234/basePath/givenPath */
export function clientFullUrl(path: string) {
  return `${clientBaseUrl()}${clientUrlPath(path)}`;
}

/** redirectTo is supposed to be a path without basePath, same as default_first_page_url */
export function getRedirectToForExplicitLogin() {
  const parsedQueryString = queryString.parse(window.location.search);
  const { redirectTo } = parsedQueryString;

  let url: string = redirectTo ? redirectTo.toString() : "";

  if (!url || !url.startsWith("/")) {
    // allow relative URLs only, ensure we don't redirect to external URLs
    const { configuration } = getStore().getState().configuration;
    url = configuration.default_first_page_url;
  }

  return url;
}
